import { Button, CircularProgress, Container, makeStyles, Menu, MenuItem, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getLeaderBoard } from '../../actions';
import { DataGrid } from '@material-ui/data-grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


const useStyles = makeStyles(() => ({
    root: {
        textAlign: 'center',
    }, titleHeader: {
        margin: '20px'
    }, sortByButton: {
        margin: '0px 0px 20px'
    }
}));

const columns = [
    { field: 'userName', headerName: 'User Name', flex: .8 },
    { field: 'wordMoney', headerName: 'Money', type: 'number', flex: .6 },
    { field: 'wordsLearned', headerName: 'Words Learned', type: 'number', flex: 1 },
    { field: 'avgProficiency', headerName: 'Avg Proficiency', type: 'number', flex: 1 },

]
const smallColumns = (fieldName, header) => [
    { field: 'userName', headerName: 'User Name', flex: 1 },
    { field: fieldName, headerName: header, type: 'number', flex: 1 },


]

const LeaderBoard = () => {
    const classes = useStyles();
    const theme = useTheme();
    const leaderBoard = useSelector(state => state.leaderBoard)
    const dispatch = useDispatch();
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));
    const [anchorEl, setAnchorEl] = useState(null);
    const [secondColumnSort, setSecondColumnSort] = useState(smallColumns('avgProficiency', 'Avg Prof.'));

    const handleSortingMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleSortingMenuClose = (nextCol) => {
        switch (nextCol) {
            case 'avgProficiency':
                setSecondColumnSort(smallColumns('avgProficiency', 'Avg Prof.'));
                break;
            case 'wordMoney':
                setSecondColumnSort(smallColumns('wordMoney', 'Money'));
                break;
            case 'wordsLearned':
                setSecondColumnSort(smallColumns('wordsLearned', 'Wds. Learned'));
                break;
            default:
                break;
        }
        setAnchorEl(null);
    }



    if (leaderBoard.leaderBoard === null) {
        dispatch(getLeaderBoard());
    }

    const renderThis = (board) => {
        if (board.leaderBoard === null || board?.leaderBoard[0].id === null) {
            return <CircularProgress />
        }
        if (isMdOrUp) {
            return <DataGrid disableColumnMenu autoHeight autoPageSize rows={board.leaderBoard} columns={columns} disableSelectionOnClick />
        }
        return <DataGrid disableColumnMenu autoHeight autoPageSize rows={board.leaderBoard} columns={secondColumnSort} disableSelectionOnClick />

    }

    return (
        <Container className={classes.root}>
            <Typography className={classes.titleHeader} color='primary' variant={isMdOrUp ? 'h2' : 'h4'}> Leader Boards</Typography>
            {isMdOrUp ? null :
                <>
                    <Button className={classes.sortByButton} size='small' onClick={handleSortingMenuOpen} variant='contained' endIcon={<ExpandMoreIcon />}  >
                        Sort By
                    </Button>
                    <Menu id="sortByMenu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => handleSortingMenuClose()}>
                        <MenuItem onClick={() => handleSortingMenuClose('wordMoney')}>Money</MenuItem>
                        <MenuItem onClick={() => handleSortingMenuClose('avgProficiency')}>Avg Proficiency</MenuItem>
                        <MenuItem onClick={() => handleSortingMenuClose('wordsLearned')}>Words Learned</MenuItem>
                    </Menu>



                </>
            }

            {renderThis(leaderBoard)}
        </Container>
    )
}

export default LeaderBoard
